export default {
  baseUrlMicrofrontend: "https://app.qa-auth.surepoint.cloud",
  ssoApiBaseUrl: "https://apiv2.qa-auth.surepoint.cloud",
  addInDomainUrl: "https://addin.qa-auth.surepoint.cloud",
  ICON_BASE_URL:
    "https://frontend-icon-store-nonprod.s3.us-east-2.amazonaws.com/fe-sso/qa/public/",
};

export const env_name = "qa";
